import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { publicGuard } from './core/guards/public.guard';
import { ownerGuard } from './core/guards/owner.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    canActivate: [publicGuard],
    loadComponent: () => import('./auth/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        title: 'Dashboard'
      },
      {
        path: 'historial',
        loadComponent: () => import('./features/historial/historial.component').then(m => m.HistorialComponent),
        title: 'Historial'
      },
      {
        path: 'reportes',
        loadComponent: () => import('./features/reporteria/reporteria.component').then(m => m.ReporteriaComponent),
        title: 'Reportes'
      },
      {
        path: 'asistencia',
        loadComponent: () => import('./features/asistencia/asistencia.component').then(m => m.AsistenciaComponent),
        title: 'Asistencia'
      },
      {
        path: 'metrics',
        loadComponent: () => import('./features/metrics/metrics.component').then(m => m.MetricsComponent),
        title: 'Métricas'
      },
      {
        path: 'facturacion',
        loadChildren: () => import('./features/facturacion/facturacion.routes').then(m => m.FACTURACION_ROUTES)
      },
      {
        path: 'configuracion',
        loadComponent: () => import('./features/configuracion/configuracion.component').then(m => m.ConfiguracionComponent),
        title: 'Configuración'
      },
      {
        path: 'sistemas',
        canActivate: [ownerGuard],
        loadComponent: () => import('./features/sistemas/sistemas.component').then(m => m.SistemasComponent),
        title: 'Sistemas'
      },
      {
        path: '404',
        loadComponent: () => import('./layout/not-found/not-found.component').then(m => m.NotFoundComponent),
        title: '404 - No encontrado'
      },
      { path: '**', redirectTo: '404' }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./layout/not-found/not-found.component').then(m => m.NotFoundComponent),
    title: '404 - No encontrado'
  }
];
